import { canUseFeature, FeatureKey } from "./plan";
import { useBabyContext } from "../context/BabyContext";

/**
 * Whether the viewer may add to or change a feature on the baby being viewed.
 *
 * Asks about the baby's plan, never the viewer's own subscription: the parent
 * pays for the journal and invited family add to it, and the free plan keeps
 * three books editable for everyone. When this is false the page is read-only —
 * what is already there stays visible, only the controls that write are off.
 */
export const useCanEdit = (feature: FeatureKey): boolean => {
  const { babyHasActivePayment } = useBabyContext();
  return canUseFeature(feature, babyHasActivePayment);
};
